import { Icono } from '../Layout/iconos';
import { FilaLlamada } from './FilaLlamada';
import type { LlamadaFeedRow } from '@/types/llamadas';

// Panel izquierdo del prototipo: cabecera con filtro por día + contador,
// lista de llamadas con estados vacío / cargando / error explícitos
// (nunca pantalla en blanco, spec §3).

export function FeedLlamadas({
  llamadas,
  dia,
  onCambiarDia,
  seleccionadaId,
  onSeleccionar,
  cargando,
  error,
  onReintentar,
}: {
  llamadas: LlamadaFeedRow[];
  dia: string;
  onCambiarDia: (dia: string) => void;
  seleccionadaId: string | null;
  onSeleccionar: (id: string) => void;
  cargando: boolean;
  error: string | null;
  onReintentar: () => void;
}) {
  return (
    <div
      data-testid="feed-llamadas"
      className="flex min-h-0 flex-col rounded-[var(--radius)] border border-[var(--border)] bg-[var(--surface)] shadow-[var(--shadow-soft)]"
    >
      <div className="flex items-center gap-2.5 border-b border-[var(--border-soft)] px-4 py-3">
        <Icono nombre="phone" className="h-4 w-4 shrink-0 text-[var(--text-dim)]" />
        <h2 className="m-0 text-[13.5px] font-semibold text-[var(--navy)]">Llamadas</h2>
        <div className="flex-1" />
        <input
          type="date"
          aria-label="Día"
          value={dia}
          onChange={(e) => onCambiarDia(e.target.value)}
          className="rounded-lg border border-[var(--border)] bg-[var(--surface)] px-2.5 py-1.5 text-[12.5px] font-medium text-[var(--navy)] hover:bg-[var(--surface-2)] focus-visible:outline-none focus-visible:border-[var(--orange)] focus-visible:shadow-[var(--ring)]"
        />
        <span className="text-[11.5px] text-[var(--text-mute)]">
          {llamadas.length} {llamadas.length === 1 ? 'llamada' : 'llamadas'}
        </span>
      </div>

      <div className="min-h-0 flex-1 space-y-1 overflow-y-auto p-2">
        {cargando && (
          <div className="px-3 py-8 text-center text-[12.5px] text-[var(--text-dim)]">
            Cargando llamadas…
          </div>
        )}

        {!cargando && error && (
          <div data-testid="feed-error" className="px-3 py-8 text-center">
            <p className="text-[12.5px] text-[var(--text-dim)]">
              No pude cargar las llamadas del día.
            </p>
            <button
              type="button"
              onClick={onReintentar}
              className="mt-3 rounded-[var(--radius-sm)] border border-[var(--border)] bg-[var(--surface)] px-3.5 py-1.5 text-[12.5px] font-medium text-[var(--text-2)] hover:bg-[var(--surface-2)] cursor-pointer"
            >
              Reintentar
            </button>
          </div>
        )}

        {!cargando && !error && llamadas.length === 0 && (
          <div data-testid="feed-vacio" className="px-3 py-10 text-center">
            <Icono nombre="phone" className="mx-auto h-6 w-6 text-[var(--text-mute)]" />
            <p className="mt-3 text-[12.5px] text-[var(--text-dim)]">
              Sin llamadas este día. Cuando el bot atienda una, aparecerá aquí en directo.
            </p>
          </div>
        )}

        {!cargando &&
          !error &&
          llamadas.map((l) => (
            <FilaLlamada
              key={l.id}
              llamada={l}
              seleccionada={l.id === seleccionadaId}
              onSeleccionar={() => onSeleccionar(l.id)}
            />
          ))}
      </div>
    </div>
  );
}
